export const Card = (props) => {
    const { label, datas } = props;
    let href, name, images;
    switch (label) {
        case 'home':
        case 'park':
        case 'univers':
        case 'archives':
        default:
            return (
                datas.map((item, i) => {
                    href = item.href;
                    name = item.name;
                    images = item.images;
                    return (
                        <a className="card" href={href} alt={name} title={name} key={i}>
                            <div className="icon">
                                <img className="img" src={images} title={name} alt={name} loading="lazy" />
                            </div>
                            <div className="legend">{name}</div>
                        </a>
                    )
                })
            )
        case 'attraction':
        case 'archive':
        case 'origin':
        case 'character':
        case 'outlinks':
            return (
                datas.map((item, i) => {
                    name = (label === 'character' | label === 'outlinks') ? 'Steamboat Willie (1928)' : item.name;
                    return (
                        item.images.map((src, i) => {
                            return (
                                <div className="card" key={i}>
                                    <div className="icon">
                                        <img className="img" src={src} title={name} alt={name} loading="lazy" />
                                    </div>
                                    <div className="legend">{name}</div>
                                </div>
                            )
                        })
                    )
                })
            )
    }
}